var _a;
import { Emergency, EmergencyFilled, MinusCircle, MinusTriangle, PlusCircle, } from 'shared/assets/icons';
export var AssessmentRisk;
(function (AssessmentRisk) {
    AssessmentRisk["low"] = "Low";
    AssessmentRisk["lowMedium"] = "Low / Medium";
    AssessmentRisk["medium"] = "Medium";
    AssessmentRisk["high"] = "High";
})(AssessmentRisk || (AssessmentRisk = {}));
export var AssessmentRiskRender = (_a = {},
    _a[AssessmentRisk.low] = {
        icon: MinusCircle,
        size: 'body1',
        iconColor: 'gray.400',
        color: 'gray.700',
        copy: 'Normal',
        emphasis: 'medium-emphasis',
        colorScheme: 'neutral',
    },
    _a[AssessmentRisk.lowMedium] = {
        icon: MinusTriangle,
        size: 'body1',
        iconColor: 'gray.400',
        color: 'gray.600',
        copy: 'Mild',
        emphasis: 'medium-emphasis',
        colorScheme: 'info',
    },
    _a[AssessmentRisk.medium] = {
        icon: Emergency,
        size: 'body2',
        iconColor: 'orange.500',
        color: 'orange.500',
        copy: 'Medium',
        emphasis: 'medium-emphasis',
        colorScheme: 'warning',
    },
    _a[AssessmentRisk.high] = {
        icon: EmergencyFilled,
        size: 'body2',
        iconColor: 'red.500',
        color: 'red.500',
        copy: 'High',
        emphasis: 'medium-emphasis',
        colorScheme: 'negative',
    },
    _a);
export var AssessmentPositiveRender = {
    icon: PlusCircle,
    size: 'body2',
    iconColor: 'gray.400',
    color: 'gray.400',
    emphasis: 'medium-emphasis',
    colorScheme: 'neutral',
};
export var AssessmentPositiveButSIB = {
    icon: EmergencyFilled,
    size: 'body2',
    iconColor: 'red.500',
    color: 'red.500',
    emphasis: 'high-emphasis',
    colorScheme: 'negative',
};
export var AssessmentNegativeRender = {
    icon: PlusCircle,
    size: 'body2',
    iconColor: 'gray.400',
    color: 'gray.400',
    emphasis: 'medium-emphasis',
    colorScheme: 'neutral',
};
// Based on https://docs.google.com/spreadsheets/d/1jiwq_HwiYm_NZ_KyQMg-pwIRG03wD1pzkPmupawCX8I/edit#gid=0, MDQ will be changed to not be pos/negative eventually
export var AssessmentPositiveNegativeKinds = ['Issues', 'SIB', 'SDS', 'MDQ']; // TODO remove MDQ
// used for secondary sort by risk if assessment is from same day
// LOW or NEGATIVE -> LOW/MEDIUM -> POSITIVE -> MEDIUM -> HIGH
export var AssessmentRiskLevelSequence = [
    AssessmentRisk.lowMedium,
    'positive',
    AssessmentRisk.medium,
    AssessmentRisk.high,
];
